<!-- Offer Group Customer Dialog (Alt+O). Chrome comes from styles/components/_dialogs.scss; Tab order between the
     input and the footer buttons is driven by keyboard-navigation.service (#offerGroupSkipBtn / #offerGroupContinueBtn). -->
<p-dialog
  [(visible)]="visible"
  (onHide)="onClose()"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="pos-dlg pos-dlg-sm premium-dialog"
  [showHeader]="false"
>
  <div class="premium-dialog-container">
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">Offer Group Pricing</h3>
        <p class="premium-subtitle">Select customer for special pricing</p>
      </div>
      <button
        class="premium-close-btn"
        (click)="onClose()"
        type="button"
        aria-label="Close dialog"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="premium-body offer-group-body">
      <!-- Loading State -->
      <div *ngIf="loadingCustomers" class="premium-loading-state">
        <div class="loading-spinner-wrapper">
          <i class="pi pi-spin pi-spinner"></i>
        </div>
        <span class="loading-text">Loading customer data...</span>
      </div>

      <!-- Main Form -->
      <div *ngIf="!loadingCustomers" class="offer-group-form">
        <div class="offer-group-field">
          <label for="offerGroupMobileNumber" class="offer-group-label">
            <span>Customer Mobile Number</span>
            <!-- <span class="optional-badge">Optional</span> -->
          </label>
          <div class="input-with-icon-wrapper">
            <i class="pi pi-mobile input-leading-icon"></i>
            <p-autoComplete
              #offerGroupMobileAutocomplete
              [ngModel]="customerMobile"
              (ngModelChange)="onCustomerMobileChange($event)"
              [suggestions]="filteredCustomersForOfferGroup"
              (completeMethod)="onFilterCustomers($event)"
              (onSelect)="onOfferGroupMobileSelect($event)"
              optionLabel="mobile_no"
              [dropdown]="false"
              [forceSelection]="false"
              [minLength]="0"
              [showEmptyMessage]="true"
              emptyMessage="No customers found"
              placeholder="Enter mobile number or customer name"
              appendTo="body"
              styleClass="customer-name-autocomplete-header offer-group-autocomplete"
              panelStyleClass="offer-group-autocomplete-panel"
              inputId="offerGroupMobileNumber"
              inputStyleClass="offer-group-input"
              (keydown)="handleOfferGroupDialogTabNavigation($event)"
            >
              <ng-template let-customer pTemplate="item">
                <div class="customer-option-row">
                  <div class="customer-avatar">
                    <i class="pi pi-user"></i>
                  </div>
                  <div class="customer-info">
                    <span class="customer-name-text">{{ customer.customer_name }}</span>
                    <span class="customer-mobile-text">{{ customer.mobile_no }}</span>
                  </div>
                  <div class="customer-mobile-pill">
                    <i class="pi pi-phone"></i>
                    <span>{{ customer.mobile_no }}</span>
                  </div>
                </div>
              </ng-template>
            </p-autoComplete>
          </div>
          <p class="offer-group-hint">
            <i class="pi pi-info-circle"></i>
            Search by mobile number or customer name
          </p>
        </div>

        <!-- Customer Found Status -->
        <div *ngIf="selectedCustomer" class="offer-status-card success">
          <div class="status-icon-badge">
            <i class="pi pi-check-circle"></i>
          </div>
          <div class="status-content">
            <div class="status-header">
              <span class="status-title">Customer Found</span>
              <span class="status-chip success">Verified</span>
            </div>
            <div class="status-name">{{ selectedCustomer.customer_name }}</div>
            <div
              *ngIf="selectedCustomer.sellingpricegroup_id"
              class="status-info"
            >
              <i class="pi pi-sparkles"></i>
              <span>Auto-selecting pricing group</span>
            </div>
          </div>
        </div>

        <!-- Customer Not Found Status -->
        <div
          *ngIf="
            !selectedCustomer && customerMobile && customerMobile.length >= 10
          "
          class="offer-status-card warning"
        >
          <div class="status-icon-badge">
            <i class="pi pi-exclamation-triangle"></i>
          </div>
          <div class="status-content">
            <div class="status-header">
              <span class="status-title">Customer Not Found</span>
              <span class="status-chip warning">Default Pricing</span>
            </div>
            <div *ngIf="selectedOfferGroupId" class="status-info">
              <i class="pi pi-info-circle"></i>
              <span>Using default pricing group</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="premium-footer" *ngIf="!loadingCustomers">
      <button
        id="offerGroupSkipBtn"
        (click)="proceedWithoutCustomer()"
        (keydown)="handleOfferGroupDialogTabNavigation($event)"
        class="premium-btn premium-btn-secondary"
        type="button"
      >
        <i class="pi pi-forward"></i>
        Skip & Select Manually
      </button>
      <button
        id="offerGroupContinueBtn"
        (click)="proceedWithCustomer()"
        (keydown)="handleOfferGroupDialogTabNavigation($event)"
        [disabled]="!customerMobile || customerMobile.length !== 10"
        class="premium-btn premium-btn-primary"
        type="button"
      >
        <span>Continue</span>
        <i class="pi pi-arrow-right"></i>
      </button>
    </div>
  </div>
</p-dialog>
